import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDashboardPermissions } from '@components';
import { useMediaQueryContext } from '@fourthwall/components';
import { useOnceInView, useTagManager } from '@hooks';
import { routing } from '@utils/routing';
import { useRecommendationsDismiss } from '../../../Recommendations/hooks/useRecommendationsDismiss';
import * as Carousel from '../../components/Carousel/Carousel';
import { MiniRecommendationDismissButton } from '../../components/MiniRecommendationDismissButton/MiniRecommendationDismissButton';
const ID = 'thankSupporters';
const CarouselItem = styled(Carousel.Item) `
  background-color: rgba(255, 68, 162, 0.15);

  &:hover {
    background-color: rgba(255, 68, 162, 0.25);
  }
`;
export const ThankSupportersSlide = ({ data, 'data-role': dataRole, resetSlider, }) => {
    const { tablet } = useMediaQueryContext();
    const { thankYous } = data;
    const { dashboardPermissions } = useDashboardPermissions();
    const tagManager = useTagManager();
    const navigate = useNavigate();
    const { recommendationsDismiss } = useRecommendationsDismiss();
    const viewRef = useOnceInView(() => {
        tagManager.trigger('mini_recommendation_view', {
            type: ID,
        });
    });
    if (!dashboardPermissions.contributions.thankYous) {
        return null;
    }
    if (!thankYous.kudosOrdersCount?.count || !recommendationsDismiss.thankYou.visible) {
        return null;
    }
    const redirectToThankYous = () => {
        tagManager.trigger('mini_recommendation_click', {
            type: ID,
        });
        navigate(routing.contributions.thankYous.self);
    };
    return (React.createElement(CarouselItem, { ref: viewRef, "data-role": dataRole, "data-analytics": ID, onClick: redirectToThankYous },
        React.createElement(Carousel.ContentLeft, null,
            React.createElement(Carousel.ItemEmote, null, "\uD83D\uDC8C"),
            !tablet && React.createElement(Carousel.ItemText, null, "Thank your supporters"),
            tablet && React.createElement(Carousel.ItemText, null, "Thank your top supporters")),
        recommendationsDismiss.thankYou.visible && (React.createElement(MiniRecommendationDismissButton, { onDismiss: () => {
                recommendationsDismiss.thankYou.dismiss();
                tagManager.trigger('mini_recommendation_dismiss', {
                    type: ID,
                });
                setTimeout(() => {
                    resetSlider();
                }, 0);
            } }))));
};
